import {ModalsProvider} from '@mantine/modals';
import React, {Fragment} from 'react';

import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import {ZINDEX_FLOATING_UI} from 'styles/StyleConstants';

export const MANTINE_MODALS_PROVIDER_ID = 'benchling-mantine-modals-provider';

/** Mounts a dedicated React root that owns the Mantine Modal Provider for the page. */
export function initModalsProvider(): void {
  const modalContainer = document.createElement('div');
  modalContainer.className = 'mantine-modals-provider';
  modalContainer.id = MANTINE_MODALS_PROVIDER_ID;
  document.body.appendChild(modalContainer);
  renderToDOM(
    <ModalsProvider modalProps={{zIndex: ZINDEX_FLOATING_UI}}>
      <Fragment />
    </ModalsProvider>,
    modalContainer
  );
}
